export class AdminApproveAlbumPhotosController {
  constructor($scope, $modal, AdminService, PhotoService, toastr, $timeout) {
    this.scope = $scope;
    this.modal = $modal;
    this.toastr = toastr;
    this.timeout = $timeout;
    this.AdminService = AdminService;
    this.PhotoService = PhotoService;
    this.scope.vm = this;
    this.scope.allUsers = {};
    this.scope.allUsersSelected = false;
    this.scope.usersSelected = {};
    this.scope.photosStatus = {};
    this.triggerCountdown = 0;
    this.scope.photosSelected;

    this.scope.pagination = {
      total: 0,
      currentPage: 1,
      limit: 12
    };

    this.scope.showModal = {
      feedback: false
    };

    this.scope.feedback = {
      toId: '',
      fromId: '',
      reason: '',
      extraMessage: ''
    };

    this.scope.feedbackMessages = [
      //"id" : 1,
      {
        "text": "Personal",
        "value": "Estimado Usuario:\n\n\n\n\n\nAtentamente\n" + "Datingchile.cl" + "\n"
      }, {
        //"id" : 2,
        "text": "Foto sin compañía",
        "value": "Es necesario que subas tu foto nuevamente ya que debes salir solo en las fotografías, sin compañía de nadie porque es muy fácil confundir a los usuarios.\n Te pedimos que cargues nuevamente una foto en donde sólo salga tu rostro.\n\nAtentamente\n" + "Datingchile.cl" + "\n\n\n"
      }, {
        //"id" : 3,
        "text": "Fotografía muy profesional",
        "value": "Lamentablemente tenemos un problema con tu fotografía debido a que se ve muy profesional.\n Te recordamos que por favor no subas:\n * Fotos de estudio\n* Modelos\n*Actores o actrices\n\nAdemás te reiteramos que sólo puedes colocar una foto de tu rostro y en la que pueda distinguirse claramente.\nSi es que nos estamos equivocando, te pedimos por favor subir otra fotografía para verificar la autenticidad de esta.\n\nAtentamente\n" + "Datingchile.cl" + "\n\n\n"
      }, {
        //"id" : 5,
        "text": "Foto original, sin filtros y graficas",
        "value": "Lamentablemente tenemos un pequeño problema con tu fotografía. Te pedimos si puedes cambiarla y por favor subir una foto original, sin gráficas, sobrepuesta, sin marcos y sin filtros.\nMuchas gracias y disculpa las molestias.\n\nAtentamente\n" + "Datingchile.cl" + "\n\n\n"
      }, {
        //"id" : 6,
        "text": "Cara Claramente visible",
        "value": "Lamento interrumpirte, pero necesitamos que por favor cargues nuevamente tu foto de perfil ya que no es posible apreciar claramente tu rostro. Debe ser una imagen en donde tu cara pueda distinguirse.\n\n    * Debes estar mirando de frente\n    * La fotografía debe ser de una calidad adecuada en donde tu rostro no salga borroso, por lo tanto trata de no subir una foto muy pequeña o sacada con un celular.\n    No debes estar muy lejos, porque te ves muy pequeño y no se puede ver bien tu cara.\n\nAtentamente\n" + "Datingchile.cl" + "\n\n\n"
      }, {
        //"id" : 7,
        "text": "Foto no cumple con las condiciones",
        "value": "Lamentablemente tu foto no cumple con las condiciones de la página. Tenemos una norma de que solo puedes mostrar desde el pecho para arriba, a menos que estás en una situación normal, como en la playa por ejemplo. Además no se aceptará ninguna foto que tenga posiciones demasiado eróticas o imágenes vulgares.\n\nAtentamente\n" + "Datingchile.cl" + "\n\n\n"
      }, {
        //"id" : 12,
        "text": "Fotografía en mala posición",
        "value": "Recuerda que al subir tu fotografía, debes darte cuenta que esté en la posición correcta, de rostro derecho y frontal para que los usuarios puedan visualizar correctamente tu cara.\n\nAtentamente\n" + "Datingchile.cl" + "\n\n\n"
      }, {
        //"id" : 14,
        "text": "Fotografía sin Morisquetas",
        "value": "Te pedimos que por favor cargues otra foto nuevamente, porque no es posible subir imágenes en donde salgas haciendo morisquetas (sacar a lengua, cerrar los ojos, hacer algún gesto con las manos, etc.) debido a que tu rostro no puede apreciarse claramente y eso es importante para que los demás usuarios puedan verte.\n\nAtentamente\n" + "Datingchile.cl" + "\n\n\n"
      }
    ];

    this.scope.allUsersSelected = {
      state: false
    };
    this.init();
  }

  init() {
    this.scope.changeLimit = () => {
      this.timeout.cancel(this.limitTimout);

      this.limitTimout = this.timeout(() => {
        this.scope.getFilterUsers(1);
      }, 200);
    };

    this.scope.selectAllUsers = () => {
      _.forEach(this.scope.usersSelected, (val, key) => {
        this.scope.usersSelected[key] = !!this.scope.allUsersSelected.state;

        _.forEach(this.scope.usersSelected, (user, key) => {
          this.scope.checkChildren(key, this.scope.allUsersSelected.state);
        });
      })
    };

    this.scope.openFeedbackModal = () => {
      var stop = true;

      _.forEach(this.scope.photosStatus, (photos, userId) => {
        let check = _.some(photos, function(val) {
          return val === true;
        });

        if(check) {
          stop = false;
          return false
        }
      });

      if(stop) return;

      this.scope.hideModal();
      this.scope.showModal.feedback = true;
      //this.scope.feedback.toId = userId;
      $('#modal').modal('show');
    };

    this.scope.hideModal = () => {
      this.scope.showModal.feedback = false;
      this.scope.showModal.image = false;
    };

    this.scope.getFilterUsers = (page) => {
      this.scope.pagination.currentPage = page;
      var limit = this.scope.pagination.limit;
      this.AdminService.albumphotosList(page, limit)
        .then((_res) => { let response = _res.data;
          if(response.success){
            this.scope.allUsers = response.data;
            this.scope.pagination.total = response.itemCount;

            // Remove old user's keys when being navigated to new page
            this.scope.usersSelected = {};
            this.scope.photosStatus = {};

            _.forEach(this.scope.allUsers, (user) => {
              this.scope.usersSelected[user._id] = false;

              _.forEach(user.albumphotos, (photo) => {
                if(!this.scope.photosStatus[user._id]) this.scope.photosStatus[user._id] = {};
                this.scope.photosStatus[user._id][photo._id] = false;
              })
            });

            this.scope.allUsersSelected.state = false;
          }
        })
        .catch((response) => { let error = response.data;
          console.log('Cannot get new users:   ', error);
        });
    };

    this.scope.approvePhotos = () => {
      let photosToApprove = _.reduce(this.scope.photosStatus, (result, photos, userId) => {
        _.forEach(photos, (val, photoId) => {
          if(val) {
            if(!result[userId]) result[userId] = [];
            result[userId].push(photoId);
          }
        });

        return result;
      }, {});

      if(_.isEmpty(photosToApprove)) {
        alert('Nothing to approve!');
        return;
      }

      if(!confirm('Do you really want to approve photo?')) {
        return;
      }

      this.PhotoService.approvePhoto({
        photos: photosToApprove
      })
      .then((response) => {
        this.scope.photosStatus = {};
        this.refreshPage();
      })
      .catch((response) => { let err = response.data;
        console.error(err);
        // Without this the request failed in silence and the photos looked
        // approved until the admin reloaded the queue.
        this.toastr.error('The photos could not be approved');
      })
    };

    this.scope.sendFeedback = (formReport) => {

      if (!formReport.$valid) {
        this.formValidationForReport(formReport);
        return;
      }

      if (this.scope.feedback.reason === "" || this.scope.feedback.extraMessage === "") {
        this.toastr.error('Feedback hasn\'t sent. You must add message');
        return;
      }

      this.scope.declinePhotos();
    };

    this.scope.declinePhotos = (approveAll) => {
      if(!confirm('Do you really want to reject photo?')) {
        return;
      }

      let photosToDecline = _.reduce(this.scope.photosStatus, (result, photos, userId) => {
        _.forEach(photos, (val, photoId) => {
          if(val) {
            if(!result[userId]) result[userId] = [];
            result[userId].push(photoId);
          }
        });

        return result;
      }, {});

      this.PhotoService.rejectPhoto({
        photos: photosToDecline,
        reason: this.scope.feedback.reason.text,
        motivation: this.scope.feedback.extraMessage
      })
      .then((response) => {
        this.scope.photosStatus = {};
        this.refreshPage();
        // Reset fields
        this.scope.feedback.reason = '';
        this.scope.feedback.extraMessage = '';
        $('#modal').modal('hide');
      })
      .catch((response) => { let err = response.data;
        console.error(err);
        // The modal stays open with the message intact so the decline can be
        // retried, rather than failing silently behind a closed dialog.
        this.toastr.error('The photos could not be declined');
      })
    };

    this.scope.checkChildren = (userId, state) => {
      _.forEach(this.scope.photosStatus[userId], (val, key) => {
        this.scope.photosStatus[userId][key] = state;
      })
    };

    this.scope.getFilterUsers(1);
  }

  /**
   * Reports the first field the feedback form is missing.
   *
   * sendFeedback() has always called this, but it was never defined on this
   * controller, so submitting an incomplete form threw a TypeError and the
   * Send button appeared to do nothing at all.
   */
  formValidationForReport(form) {
    if (form.$valid) {
      return true;
    }

    const messages = {
      reason: 'Please, select the reason',
      extra_message: 'Please, add a message'
    };

    const invalid = _.findKey(messages, (message, name) => form[name] && form[name].$invalid);

    this.toastr.error(invalid ? messages[invalid] : 'Please, complete the form');

    const field = $(`form[name="${form.$name}"] *[name="${invalid}"]`);
    if (field.length) {
      field[0].focus();
    }

    return false;
  }

  /**
   * Refresh page content and pagination
   */
  refreshPage() {
    // Calculates amount of users have been approved (were removed from total)
    var itemsRemoved = _.size(this.scope.usersSelected);
    _.forEach(this.scope.usersSelected, (val, key) => {
      if (val === false) { itemsRemoved--; }
    } );

    // Stay on the current page unless the removals put it past the end of the
    // shortened list.
    var lastPage = Math.max(1, Math.ceil((this.scope.pagination.total - itemsRemoved) / this.scope.pagination.limit));
    var page = Math.min(this.scope.pagination.currentPage, lastPage);

    this.scope.getFilterUsers(page);
  }
}
